import { useContext } from 'react';
import {
	Redirect, Route
} from 'react-router-dom';
import { LOGGED_IN } from '../constants/AuthStatus';
import { AuthContext } from '../contexts/AuthContext';


export default function PublicRoute({ component: Component, ...rest }) {
	const authContext = useContext(AuthContext)
	const { authStatus } = authContext
	return (
		<Route
			{...rest}
			render={(props) =>
				authStatus !== LOGGED_IN ? (
					<Component {...props} />
				) : (
					<Redirect
						to={{
							pathname: '/notifications',
							state: { from: props.location }
						}}
					/>
				)
			}
		/>
	)
}